export enum OrderCopyAccountErrorEnum {
  UserUnauthorized = 'user_unauthorized',
  DuplicateAccount = 'duplicate_account',
}
